import React, { useState } from "react";
import "./pages1.scss";
import {send} from '@emailjs/browser';
export default function ContactForm() {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    subject: "",
    message: "",

 
  });
  const [toSend,setTosend]=useState({
    from_name: '',
    to_name: '',
    message: '',
    reply_to: '',
  })
  const handleChange = (event: any) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
    setTosend({...toSend,
      from_name:formData.firstname+' '+formData.lastname,
      to_name: 'Abiboulaye Diagne',
      message: "Email: "+formData.email+" \nPhone Number: "+formData.phone+" \nSubject: "+ formData.subject+" \nMessage: "+formData.message,
      reply_to: '',
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    if(formData.firstname!=="" && formData.lastname!=="" && formData.email!==""){send('service_bgy2z7t', 'template_5je2jm6', toSend, 'vcbfm0cNvSLCifjo7')
    .then((result) => {
        console.log(result.text, toSend); alert("Thank you "+ formData.firstname +" for reaching out to me, I will respond to your message as soon as possible.\n\nThank you\nAbiboulaye.");window.location.href = 'https://unrivaled-sopapillas-a4011f.netlify.app';
    }, (error) => {
        console.log(error.text);

    });}
    else{
      alert("Please fill the whole form.")
    }
  };

  return (
    <div className="Form">
      <form onSubmit={handleSubmit}>
        <div className="firs">
          <div className="placeholder">
            <label htmlFor="firstname">First Name</label>
            <input
              type="text"
              id="firstname"
              className="placeh pla"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
            />
          </div>
          <div className="placeholder">
            <label htmlFor="lastname">Last Name</label>
            <input
              className="placeh pla"
              type="text"
              id="lastname"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="seco">
          <div className="placeholder">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="placeh pla"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="placeholder">
            <label htmlFor="phone">Phone</label>
            <input
              type="text"
              id="phone"
              className="placeh pla"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="plac">
          <label htmlFor="Subject">Subject</label>
          <input
            type="text"
            id="subject"
            className="placeh"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
          />
        </div>
        <div className="plac">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            className="placehold placeh"
            value={formData.message}
            onChange={handleChange}
          />
        </div>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}
